import callAxios from "../../plugins/axios/call";

export default remote => ({
    simple: (departure, destination, search_type) => callAxios(remote, 'get', `flight/calendar/${ departure }/${ destination }/${ search_type }`, null, 7),
    chart : (data) => callAxios(remote, 'post', 'flight/calendar/chart', data, 8),
    search: (search_code) => callAxios(remote, 'get', `flight/calendar/search/${ search_code }`, null, 9),
    query: (data) => callAxios(remote, 'post', 'flight/calendar/query', data, 12),
    months: (data) => callAxios(remote, 'post', 'flight/calendar/months', data, 2),
});
